import Hello from './components/main.jsx';
import "./style.css";
import Logo from './img/cyberponics_logo.png';

export var logo=Logo;


// WEBPACK FOOTER //
// ./src/index.js